/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as queryString from 'query-string';
import { Link } from 'react-router-dom';

import requireAuth from '../../components/hocs/requireAuth';
import requireOnboarding from '../../components/hocs/requireOnboarding';
import * as actions from '../../actions/club-actions';
import { setupStripeAccount } from '../../api/clubsApi';

import config from '../../../config';

import styles from './clubPayments.scss';
import { getApiAxiosInstance } from '../../utils/network';

import { payments } from '../../../constants';

class ClubPaymentPage extends Component {
    constructor(props) {
        super(props);
        const { clubType, clubId } = props.match.params;
        this.state = {
            redirectUri: `${config.appHost}/${clubType}/${clubId}/payment`,
        };
    }

    async componentDidMount() {
        await this.props.setClubId(this.props.match.params.clubId);
    }

    // eslint-disable-next-line no-unused-vars
    async componentDidUpdate(prevProps, prevState) {
        console.log('component did update');
        const { club } = this.props;
        const { clubDetails } = club;
        const { clubType } = this.props.match.params;
        let { paymentProvider } = payments;
        if (clubDetails?.paymentProviderSetupType?.value) {
            paymentProvider = clubDetails.paymentProviderSetupType.value;
        }
        console.log('club', club);

        if (club && clubDetails && clubDetails.allowOffPlatformPayments) {
            this.props.history.push(`/${clubType}/${clubDetails.id}`);
        }

        const activePaymentsEnabled = clubDetails?.activePaymentProviderTypes?.find(payment => payment.value === paymentProvider);
        const setUpComplete = clubDetails?.paymentsEnabled && activePaymentsEnabled;

        if (clubDetails && !setUpComplete) {
            if (!clubDetails.tierType.enablePayments) {
                this.props.history.push('/');
            }
            console.log('detials loaded, payments not enabled');
            const queryParams = queryString.parse(this.props.location.search);
            const { clubId } = this.props.match.params;
            if (queryParams.code && !this.state.loading && !this.state.success && !this.state.error) {
                console.log('code param present');
                this.setState({ loading: true });
                try {
                    await setupStripeAccount(getApiAxiosInstance(), clubId, {
                        code: queryParams.code,
                        redirectUri: this.state.redirectUri,
                    });

                    this.props.setClubId(this.props.match.params.clubId);
                    this.setState({ loading: false, success: true });
                } catch (error) {
                    console.log(error.response);
                    this.setState({ loading: false, error: error.response ? error.response.data : 'error' });
                }
            }
        }
    }

    render() {
        const { clubType, clubId } = this.props.match.params;
        const stripeUrl =
            `${config.stripeHost}/oauth/authorize?client_id=${config.stripeClientId}` +
            `&state=${encodeURI(JSON.stringify({ clubType, clubId }))}` +
            '&response_type=code' +
            '&scope=read_write';
        const { club, auth } = this.props;
        const { clubDetails } = club;
        const { loading, error, success } = this.state;
        let paymentProvider = payments?.paymentProvider;
        if (clubDetails?.paymentProviderSetupType?.value) {
            paymentProvider = clubDetails.paymentProviderSetupType.value;
        }
        const activePaymentsEnabled = clubDetails?.activePaymentProviderTypes?.find(payment => payment.value === paymentProvider);
        const setUpComplete = clubDetails?.paymentsEnabled && activePaymentsEnabled;

        return (
            <div className={`${styles.section}`}>
                {club.clubDetails && (
                    <div className={`container h2 bg-transparent`}>
                        <div className={`text-center ${styles.clubName}`} data-testid="club-payment.page.club-name">
                            {this.props.club.clubDetails.name}
                        </div>
                        <h2 className="text-center" data-testid="club-payment.page.title">Payments Account</h2>
                    </div>
                )}
                <div className={`container bg-transparent`}>
                    {club.clubDetails && club.clubDetails.currentMember.role === 'Owner' && (
                        <React.Fragment>
                            {(!loading && !error && !success && !setUpComplete) && (
                                <React.Fragment>
                                    <div className={`row`}>
                                        <div className={`offset-md-3 col-md-6`}>
                                            {
                                                <>
                                                    <div className={`mb32`}>
                                                        <h5 data-testid="club-payment.page.provider-heading">UTR Sports Payments Powered by Stripe</h5>
                                                    </div>
                                                    <p className="mb24 taj">
                                                        UTR Sports is proud to partner with <a href="https://dashboard.stripe.com/register" target="_blanks">Stripe</a>, to facilitate payments for events on our platform.
                                                    </p>
                                                    <p className="mb24 taj">
                                                        Stripe is a secure, customizable payments platform - like Paypal - that allows us to provide the best experience for our organizers and players.
                                                    </p>
                                                    <p className="mb24 taj">
                                                        With UTR Sports Payments powered by Stripe, event organizers can seamlessly set entry fees, collect funds, distribute refunds and deposit earnings to their bank account.
                                                    </p>
                                                    <p className="mb24 taj">
                                                        It only takes a minute to create your Stripe account below and start accepting payments on UTR Sports.
                                                    </p>
                                                </>
                                            }
                                            <div className="row">
                                                <div className="col-md-6">
                                                    {
                                                        <a
                                                            href={stripeUrl}
                                                            className="btn btn-primary btn-xl text-uppercase btn-block btn-flex"
                                                            data-testid="club-payment.page.create-stripe-btn"
                                                        >
                                                            Create Stripe Account
                                                        </a>
                                                    }
                                                </div>
                                                <div className="col-md-6">
                                                    <Link
                                                        to={`/${clubType}/${club.clubDetails.id}`}
                                                        className="btn btn-default btn-xl text-uppercase btn-block btn-flex"
                                                        data-testid="club-payment.page.cancel-link"
                                                    >
                                                        Cancel
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="mt32">
                                                {
                                                    <small>Learn more and access Stripe support <a href="https://support.stripe.com/" target="_blank" rel="noopener noreferrer">here</a>.</small>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                            {(!loading && !error && (success || setUpComplete)) && (
                                <React.Fragment>
                                    <div className={`row`}>
                                        <div className={`offset-md-3 col-md-6`}>
                                            <div className={`mb32`}>
                                                <h5 data-testid="club-payment.page.confirmation-heading">Confirmation and Next Steps</h5>
                                            </div>
                                            {
                                                <>
                                                    <p className="mb24 taj">Your Stripe payments account has been created and you can start accepting entry fees for events on UTR Sports immediately!</p>
                                                    <p className="mb24 taj"><strong>Important: </strong> In order to fully activate your Stripe payments account, please follow these quick steps: </p>
                                                    <ol>
                                                        <li className="mb24 taj">
                                                            Log into your new account at <a href="https://dashboard.stripe.com/login" target="_blanks">stripe.com</a> with the details you just created.
                                                        </li>
                                                        <li className="mb24 taj">
                                                            Bookmark the page so it’s easily accessible. (<code>CMD+D</code> or <code>CTRL+D</code> on your keyboard)
                                                        </li>
                                                        <li className="mb24 taj">
                                                            Update and verify your company or personal information.
                                                        </li>
                                                        <li className="mb24 taj">
                                                            Add a bank account for withdrawing funds you collect on UTR Sports.
                                                        </li>
                                                    </ol>
                                                    <p className="mb24 taj">Anytime you’d like to view your balance, transaction history, or make a withdrawal, go to stripe.com. To refund a player, go to the Players tab on your event page. Make sure to fully complete your Stripe setup at stripe.com - if you don’t do this within 30 days, your Stripe account will be shut down and any funds made from running events will automatically refund back to the players and be unrecoverable!</p>
                                                </>
                                            }

                                            {club.clubDetails?.tierType?.id === 16 ? (
                                                <div className="row">
                                                    <div className="col-12 text-center">
                                                        <Link
                                                            to={`/profiles/${auth.user.claimedPlayer.playerId}/edit`}
                                                            className="btn btn-primary btn-xl text-uppercase btn-flex"
                                                            data-testid="club-payment.page.return-profile-link"
                                                        >
                                                            Return to your profile
                                                        </Link>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="row">
                                                    <div className="col-12 text-center">
                                                        <Link
                                                            to={`/${clubType}/${club.clubDetails.id}`}
                                                            className="btn btn-primary btn-xl text-uppercase btn-flex"
                                                            data-testid="club-payment.page.return-club-link"
                                                        >
                                                            Return to club profile
                                                        </Link>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                            {loading && (
                                <div className={`text-center`} data-testid="club-payment.page.loading">
                                    <i className="fas fa-circle-notch fa-spin" /> Setting up your account. Please wait a moment.
                                </div>
                            )}
                            {error && (
                                <div className={`text-center`}>
                                    <div className={`row`}>
                                        <div className={`offset-md-3 col-md-6`}>
                                            <div data-testid="club-payment.page.error-message">The following error was returned when trying to complete account setup:</div>
                                            <div data-testid="club-payment.page.error-detail">{error}</div>
                                            <div className="row">
                                                <div className="offset-md-3 col-md-6 text-center">
                                                    <a href={stripeUrl} className="btn btn-primary btn-xl text-uppercase btn-block">Try Again?</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                    {club.clubDetails && club.clubDetails.currentMember.role !== 'Owner' && (
                        <React.Fragment>
                            <div className={`row`}>
                                <div className={`offset-md-3 col-md-6`}>
                                    <p className="mb24" data-testid="club-payment.page.no-access-message">Please contact your club owner to manage the payments account.</p>
                                    <div className="row">
                                        <div className="offset-md-3 col-md-6 text-center">
                                            <Link
                                                to={`/${clubType}/${club.clubDetails.id}`}
                                                className="btn btn-primary btn-xl text-uppercase btn-block"
                                                data-testid="club-payment.page.no-access-return-link"
                                            >
                                                Return to club profile
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setClubId: (clubId) => {
            dispatch(actions.setClubId(clubId));
        },
    };
}

function mapStateToProps({ auth, search, header, club }) {
    return { auth, search, header, club };
}

export default requireAuth(requireOnboarding(connect(mapStateToProps, mapDispatchToProps)(ClubPaymentPage)));
